const PATH = 'fe.components.organization.table.column_filter';

const messages = {
  seeOnly: {
    key: `${PATH}.see_only`,
    defaultValue: 'See Only'
  }
};
export default messages;
